module.exports = __webpack_public_path__ + "img/u1217.1a30156e.png";